// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_33-3";
export var dialog = "_33-0";
export var divClassnameSwatch = "_33-8";
export var flexSwatch = "_33-4";
export var header = "_33-1";
export var styleAttributeSwatch = "_33-7";
export var swatch = "_33-2";
export var textHeaderSwatch = "_33-5";
export var webSwatch = "_33-6";